import { render, staticRenderFns } from "./TagsProperty.vue?vue&type=template&id=64c3f30b&"
import script from "./TagsProperty.vue?vue&type=script&lang=js&"
export * from "./TagsProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports